import { invokeApi } from "../../bl_libs/invokeApi";

// Client reviews page ("View all" on the dashboard card). Served by the dashboard API with
// client_reviews=true. scope: all | today | overdue | due (overdue + next 7 days).
// from / to (YYYY-MM-DD, both included) filter the All tab by due date.
export const clientReviewsApi = async ({
  scope = "due",
  search = "",
  page = 0,
  limit = 10,
  from = "",
  to = "",
}) => {
  // "Today" is worked out in this browser's time zone (review dates are picked and shown in it).
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const params = new URLSearchParams({
    client_reviews: "true",
    review_scope: scope,
    review_search: search,
    review_page: page,
    review_limit: limit,
    review_from: from,
    review_to: to,
    tz,
  });
  const requestObj = {
    path: `api/program/harmony_ring_program_list?${params.toString()}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  const result = await invokeApi(requestObj);
  // { code, message, rows, total, total_pages, counts }
  return { code: result?.code, message: result?.message, ...result?.client_reviews };
};
